export default __webpack_public_path__ + "static/media/teach-5.cb336de0.jpg";